import React, { useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { X, ChevronLeft, CreditCard ,ShoppingCart} from 'lucide-react';
import {BarChart,Bar,XAxis,YAxis,CartesianGrid,Tooltip as RechartsTooltip,Legend,ResponsiveContainer,PieChart,Pie,Cell} from 'recharts';
import Nav from './Nav';
import Chatbot from '../com/Chatbot';


const Sumresult = () => {
  const location = useLocation();
  const [expandedCard, setExpandedCard] = useState(null);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [showOffers, setShowOffers] = useState(false);

  // Colors for sentiment analysis
  const SENTIMENT_COLORS = {
    Positive: '#4ade80',
    Neutral: '#94a3b8',
    Negative: '#f87171'
  };

  // Platform images
  const platformImages = {
    amazon: "ecom/amazon.webp",
    flipkart: "ecom/flipkart.webp",
    vijaysales: "ecom/vijay.png",
    reliance: "ecom/reliancedi.png",
    sangeetha: "ecom/sangee.png",
    croma: "ecom/croma.png",
    unknown: "ecom/default.webp"
  };

  // Additional sections
  const additionalSections = [
    { id: "price", title: "Price Comparator" }
  ];

  // Utility function to validate JSON
  const isValidJSON = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch {
      return false;
    }
  };

  // Parsing received message
  const receivedMessage = location.state?.result || "No message received";
  const parsedData = isValidJSON(receivedMessage)
    ? JSON.parse(receivedMessage)?.results || []
    : [];

  // Memoized price comparison data
  const priceComparisonData = useMemo(() =>
    parsedData.map(item => ({
      platform: item.platform?.toUpperCase() || 'UNKNOWN',
      price: parseFloat(item.price || 0),
      title: item.title || 'No Title',
      image: item.image || 'No Image Available',
      link: item.link || 'No Link Available',
      reviews: item.reviews || 'no reviews',
      offers: item.offers?.flat() || 'no offers',
      sentiment : item.sentiments || 'not enough data'
    })).filter(item => item.price > 0)
  , [parsedData]);



  // const lowestPriceItem = priceComparisonData.reduce((acc, item) => {
  //   if (item.price < acc.price) return item;
  //   return acc;
  //   }, priceComparisonData[0]);
    

  //for the sentiment pie chart
  const parseSentiment = (sentiment) => {
    // Handle cases where sentiment might be undefined, null, or an empty array
    if (!sentiment || sentiment.length === 0) {
      return [];
    }
  
    // If sentiment is already in the correct format, return it
    if (Array.isArray(sentiment) && sentiment[0]?.label && sentiment[0]?.score !== undefined) {
      return sentiment.map(item => ({
        name: item.label.charAt(0).toUpperCase() + item.label.slice(1),
        value: Math.round(item.score * 100)
      })).sort((a, b) => b.value - a.value);
    }
  
    // If sentiment is a string representation of an array, parse it
    if (typeof sentiment === 'string') {
      try {
        const parsedSentiment = JSON.parse(sentiment);
        return parsedSentiment.map(item => ({
          name: item.label.charAt(0).toUpperCase() + item.label.slice(1),
          value: Math.round(item.score * 100)
        })).sort((a, b) => b.value - a.value);
      } catch (error) {
        console.error('Error parsing sentiment:', error);
        return [];
      }
    }
  
    // Fallback for any other unexpected formats
    return [];
  };
  
  // In your renderExpandedView or component
  const renderSentimentVisualization = (sentiment) => {
    const parsedSentiment = parseSentiment(sentiment);
  
    if (parsedSentiment.length === 0) {
      return null;
    }
  
    return (
      <div className="mt-10 mr-10 p-2 bg-gray-50 rounded-lg">
        <h4 className="font-semibold mb-3">Sentiment Analysis</h4>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={parsedSentiment}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                paddingAngle={2}
                dataKey="value"
              >
                {parsedSentiment.map((entry, index) => (
                  <Cell 
                    key={index} 
                    fill={SENTIMENT_COLORS[entry.name] || '#94a3b8'} 
                  />
                ))}
              </Pie>
              <RechartsTooltip 
                formatter={(value) => `${value}%`}
              />
              <Legend 
                verticalAlign="bottom" 
                height={36} 
                content={(props) => {
                  const { payload } = props;
                  return (
                    <ul style={{ display: 'flex', justifyContent: 'center', padding: 0 }}>
                      {payload.map((entry, index) => (
                        <li 
                          key={`item-${index}`} 
                          style={{ 
                            margin: '0 10px', 
                            listStyleType: 'none', 
                            fontSize: '14px' 
                          }}
                        >
                          <span style={{ color: entry.color, fontWeight: 'bold' }}>
                            {entry.value}
                          </span>: {entry.payload.value}%
                        </li>
                      ))}
                    </ul>
                  );
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  };









    const ProductCard = ({ data }) => {

      if (!data.title || !data.price || !data.platform || !data.link) {
        console.log("ProductCard: Missing required data", data);
        return null; // Do not render the card
      }
      
      const platformImage =
        platformImages[data.platform?.toLowerCase()] || platformImages.unknown;

        console.log(data.sentiment)
      

      // Function to parse sentiment and handle any potential issues
      
      const isExpanded = expandedCard === data;
      const validPrice = !isNaN(data.price) && data.price > 0 ? data.price : 0;



      return (
        <div
          className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-lg h-[400px] w-[300px]"
          onClick={() => setExpandedCard(isExpanded ? null : data)} // Toggle card expansion
        >
          {/* Collapsed State */}
          {!isExpanded && (
            <div className="h-1/2 w-full flex justify-center items-center bg-gray-100">
              <img
                src={platformImage || "/api/placeholder/400/400"}
                alt={data.platform}
                className="w-48 h-48 object-contain"
                onError={(e) => (e.target.src = "/api/placeholder/400/400")}
              />
              
            </div>
            
          )}

          {/* Card Content */}
          <div className="p-4">
            <h3 className="font-bold text-lg mb-2">{data.platform}</h3>
            <p className="text-sm text-gray-700 mb-2 line-clamp-2">{data.title}</p>
            <p className="text-lg font-bold text-gray-900 mb-3">
              ₹{validPrice.toFixed(2)}
            </p>
          </div>
          <div className="mr-25 flex justify-center items-center">
            <h2>
              View More
            </h2>
          </div>
        </div>
      );
    };

  

  // Offers Component
  const Offers = ({ data }) => {
    if (!data.offers || data.offers.length === 0) {
      console.log("Offers Component: No data or empty offers");
      return <p className="text-xs text-gray-500">No offers available.</p>;
    }
  
    console.log("Offers Component Data:", data);
    return (
      <ul className="space-y-2">
        {data.offers.slice(0 ,20).map((offer, index) => (
          <li key={index} className="text-xs text-gray-700">
            • {offer}
          </li>
        ))}
      </ul>
    );
  };



  // Render Expanded View
  const renderExpandedView = (data) => {
    const safeData = data || {};
    const price = safeData.price ?? 0;
    const platform = safeData.platform ?? 'UNKNOWN';
    const title = safeData.title ?? 'No Title';
    const image = safeData.image || "/api/placeholder/400/400";
    const link = safeData.link || "#";
    const reviews = safeData.reviews || 'no reveiws';
    const sentiment = safeData.sentiment || [];
  

    return (
      <div className="fixed inset-0 z-50 overflow-hidden">
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
        <div className="absolute inset-4 md:inset-8 bg-white rounded-lg shadow-2xl overflow-hidden">
          <div className="h-full flex flex-col">
            {/* Header with Back and Close buttons */}
            <div className="sticky top-0 z-10 bg-white border-b px-6 py-4 flex items-center justify-between">
              <button
                className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
                onClick={() => setExpandedCard(null)}
              >
                <ChevronLeft className="w-5 h-5 mr-2" />
                <span className="font-medium">Back</span>
              </button>
              <div>
              <h3 className="font-bold text-lg mb-2">{platform}</h3>  
              </div>
              <button
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                onClick={() => setExpandedCard(null)}
              >
              
                <X className="w-5 h-5 text-gray-600" />
              </button>
            </div>
            
            <div className="flex-1 overflow-auto p-6">
              <div className="max-w-4xl mx-auto">
                <div className="flex flex-col md:flex-row gap-8 mb-8">
                  {/* Left Column - Image and Sentiment Analysis */}
                  
                  <div className="md:w-1/3">
                    <img
                      src={image}
                      alt={title}
                      className="w-full rounded-lg shadow-md object-cover"
                      onError={(e) => {
                        e.target.src = "/api/placeholder/400/400";
                      }}
                    />

                    {renderSentimentVisualization(sentiment)}   
                    </div>
                  
                  {/* Right Column - Product Details */}
                  <div className="md:w-2/3">
                    <h2 className="text-2xl font-bold mb-4">{title}</h2>
                    
                    {/* Price and Platform Link */}
                    <div className="flex items-center gap-4 mb-6">
                      <span className="text-2xl font-bold">₹{Number(price).toFixed(2)}</span>
                      <a 
                        href={link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
                      >
                        View on {platform}
                      </a>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 mb-6">
                      <h3 className="font-semibold mb-3">Review Summary</h3>
                      {reviews && reviews.length > 0 ? (
                        <p className="text-gray-700 leading-relaxed">{reviews}</p>
                      ) : (
                        <p className="text-gray-700 leading-relaxed">Not enough data</p>
                      )}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };


  //mno proble,,

  // Render Bank Offers Modal
  const renderBankOffersModal = () => {
    if (!showOffers || !selectedPlatform) return null;
  
    const selectedItem = priceComparisonData.find(
      item => item.platform === selectedPlatform
    );
  
    if (!selectedItem || !selectedItem.offers || selectedItem.offers.length === 0) {
      return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black opacity-50"
            onClick={() => setShowOffers(false)}
          />
          <div className="bg-white p-6 rounded-lg z-60 relative w-96 border">
            <button
              onClick={() => setShowOffers(false)}
              className="absolute top-2 right-2"
            >
              <X className="text-gray-600" />
            </button>
            <h2 className="text-xl font-bold mb-4">
              No Offers Available for {selectedPlatform}
            </h2>
          </div>
        </div>
      );
    }
  
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div
          className="absolute inset-0 bg-black opacity-50"
          onClick={() => setShowOffers(false)}
        />
        <div className="bg-white p-6 rounded-lg z-60 relative w-100 border">
          <button
            onClick={() => setShowOffers(false)}
            className="absolute top-2 right-2"
          >
            <X className="text-gray-600" />
          </button>
          <h2 className="text-xl font-bold mb-4">
            Offers - {selectedPlatform}
          </h2>
          <Offers data={selectedItem} />
        </div>
      </div>
    );
  };




  // Render Price Comparator Modal
  const renderPriceComparator = () => {
    const handleBuyNow = (item) => {
      // Redirect to the platform's product link
      window.open(item.link, '_blank');



    };
    return (
      <div className="fixed inset-0 z-50 overflow-hidden">
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
        <div className="absolute inset-4 md:inset-8 bg-white rounded-lg shadow-2xl overflow-hidden">
          <div className="h-full flex flex-col">
            <div className="sticky top-0 z-10 bg-white border-b px-6 py-4 flex items-center justify-between">
              <button
                className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
                onClick={() => setExpandedCard(null)}
              >
                <ChevronLeft className="w-5 h-5 mr-2" />
                <span className="font-medium">Back</span>
              </button>
              <button
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                onClick={() => setExpandedCard(null)}
              >
                <X className="w-5 h-5 text-gray-600" />
              </button>
            </div>
            <div className="flex-1 overflow-auto p-6">
              <div className="max-w-6xl mx-auto">
                <h2 className="text-2xl font-bold mb-6">Price Comparator</h2>
                
                <div className="grid grid-cols-1 md:grid-row-2 gap-6 mb-8">
                  {/* Price Comparison Chart */}
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h3 className="font-semibold mb-4">Price Comparison Chart</h3>{/*bar width and height and grid col */}
                    <ResponsiveContainer width="100%" height={350}>   
                      <BarChart data={priceComparisonData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="platform" />
                        <YAxis />
                        <RechartsTooltip 
                          formatter={(value, name) => [`₹${value}`, name === 'price' ? 'Price' : name]}
                        />
                        <Legend />
                        <Bar 
                            dataKey="price" fill="#8884d8" name="Product Price" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  
                  {/* Detailed Price Breakdown */}
                  <div className="bg-gray-50 rounded-lg p-4 overflow-auto">
                    <h3 className="font-semibold mb-4">Detailed Price Breakdown</h3>
                    <table className="w-full text-left table-auto">
                      <thead>
                        <tr className="bg-gray-200">
                          <th className="p-3">Platform</th>
                          <th className="p-3">Price</th>
                          <th className="p-3">Product Title</th>
                          <th className="p-3">Actions</th> {/* Buy Now, Bank Offers */}
                          <th className="p-3"> buy Now</th> {/* Buy Now, Bank Offers */}
                        </tr>
                      </thead>
                      <tbody>
                        {priceComparisonData.map((item, index) => (
                          <tr key={index} 
                            className="cursor-pointer hover:bg-gray-100 transition"
                          >
                            <td className="p-3">{item.platform}</td>
                            <td className="p-3">₹{item.price.toFixed(2)}</td>
                            <td className="p-3 line-clamp-2">{item.title}</td>
                            <td className="p-3">
                              <div className="flex items-center space-x-2">
                                {/* Button to show offers */}
                                <button 
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedPlatform(item.platform);  // Set the selected platform
                                    setShowOffers(true);  // Toggle to show the offers for the clicked item
                                  }}
                                  className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 transition flex items-center"
                                >
                                  <CreditCard className="mr-2" size={16} /> Offers
                                </button>
                              </div>
                            </td>
                            <td className="p-3">
                            <button
                                  onClick={() => handleBuyNow(item)}
                                  className="bg-green-500 text-white p-2 rounded hover:bg-green-600 transition flex items-center"
                                >
                                  <ShoppingCart size={16} className="mr-1" /> Buy Now
                                </button>
                                </td>
                          </tr>
                          
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
    <Nav/>
        <div className="min-h-screen bg-gray-900 p-8">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-wrap justify-center gap-10 mb-6">
              {parsedData.map((data, index) => (
                <ProductCard key={index} data={data} />
              ))}
            </div>
            <div className="flex justify-center gap-6">
              {additionalSections.map((section) => (
                <div
                  key={section.id}
                  className="bg-blue-500 rounded-lg shadow-md overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-lg h-[10vh] w-[30vw]"
                  onClick={() => setExpandedCard({ id: section.id, title: section.title })}
                >
                  <div className="p-4">
                    <h3 className="text-center font-bold">{section.title}</h3>
                  </div>
                </div>
              ))}
            </div>
            {expandedCard && (
              expandedCard.id === "price" ? 
                renderPriceComparator() : 
                renderExpandedView(expandedCard)
            )}
            {renderBankOffersModal()}
          </div>
          <Chatbot/>
        </div>
        </>
      );
    };

export default Sumresult;